<template>
  <div class="selected-action">
    <div class="selected-action-wrapper">
      <div class="action-type-wrapper like" @click="$emit('move-top')">
        <div class="action-wrapper__icon">
          <div
            :class="[{ active: item.is_sort_up },'like selected-action']"
          >
            <IconBase height="18" width="18">
              <LikeSVG />
            </IconBase>
          </div>
          <div class="like-action__arrow">
            <IconBase height="10" icon-color="#5ab989" width="10">
              <ArrowRight />
            </IconBase>
          </div>
        </div>
        <p class="action-text hidden-xs-only">Мій фаворит</p>
      </div>
      <div class="action-type-wrapper await" @click="$emit('move-bot')">
        <div class="action-wrapper__icon">
          <div
            :class="[{ active: item.is_sort_down }, 'await selected-action']"
          >
            <IconBase height="18" width="18">
              <SandClock />
            </IconBase>
          </div>
          <div class="await-action__arrow">
            <IconBase height="10" icon-color="#ebb156" width="10">
              <ArrowRight />
            </IconBase>
          </div>
        </div>
        <p class="action-text hidden-xs-only">В роздумах</p>
      </div>
      <div class="action-type-wrapper delete" @click="$emit('delete')">
        <div class="delete selected-action">
          <IconBase height="18" width="18">
            <Delete />
          </IconBase>
        </div>
        <p class="action-text hidden-xs-only">Видалити</p>
      </div>
    </div>
  </div>
</template>

<script>
import IconBase from '@/components/icons/IconBase'
import Delete from '@/components/icons/DeleteSvg'
import LikeSVG from '@/components/icons/LikeSVG'
import SandClock from '@/components/icons/SandClock'
import ArrowRight from '@/components/icons/ArrowRight'

export default {
  name: 'ActionButton',
  props: {
    item: Object,
  },
  components: {
    ArrowRight,
    LikeSVG,
    IconBase,
    Delete,
    SandClock,
  },

}
</script>
